module.exports = __webpack_public_path__ + "img/blog2.6e9aaf61.jpeg";